import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=8d48f0b8&scoped=true&"
import script from "./ShopDetail.vue?vue&type=script&lang=js&"
export * from "./ShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=8d48f0b8&prod&scoped=true&lang=css&"
import style1 from "./ShopDetail.vue?vue&type=style&index=1&id=8d48f0b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d48f0b8",
  null
  
)

export default component.exports